import axios from 'axios';
import { getErrorMessage } from './errorHandler';

// Global error handler state
let globalErrorHandler = null;

/**
 * Set the global error handler function
 * @param {Function} handler - Function to handle errors globally
 */
export const setGlobalErrorHandler = (handler) => {
    globalErrorHandler = handler;
};

/**
 * Setup axios interceptors for global error handling
 */
export const setupAxiosInterceptors = () => {
    // Request interceptor
    axios.interceptors.request.use(
        (config) => {
            // You can add request modifications here if needed
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Response interceptor
    axios.interceptors.response.use(
        (response) => {
            // Any status code that lies within the range of 2xx causes this function to trigger
            return response;
        },
        (error) => {
            // Any status codes that falls outside the range of 2xx causes this function to trigger

            // Get appropriate error message based on error type
            const errorMessage = getErrorMessage(error);

            // Use global error handler if available
            if (globalErrorHandler && typeof globalErrorHandler === 'function') {
                globalErrorHandler(errorMessage);
            } else {
                // Fallback to alert if no global handler is set
                alert(errorMessage);
            }

            return Promise.reject(error);
        }
    );
};

/**
 * Remove axios interceptors
 */
export const removeAxiosInterceptors = () => {
    axios.interceptors.request.clear();
    axios.interceptors.response.clear();
};
